import xz from "../common";
let comTablePath;
if (location.origin.indexOf('localhost') > -1) {
    comTablePath = 'https://dev.joball.net'
} else {
    comTablePath = location.origin
}
const emp = {
    state: {
        tablePath: comTablePath + '/cloudexcel/',
        docPath: comTablePath + '/clouddoc/',
        imgPath: comTablePath + '/cloudimg/',
        vdoPath: comTablePath + '/cloudvdo/',
        //证件类型
        cardType: [{
                name: '居民身份证',
                val: 'A',
            },
            {
                name: '中国护照',
                val: 'B',
            }, {
                name: '港澳居民来往内地通行证',
                val: 'C',
            }, {
                name: '港澳居民居住证',
                val: 'D',
            }, {
                name: '台湾居民来往大陆通行证',
                val: 'E',
            }, {
                name: '台湾居民居住证',
                val: 'F',
            }, {
                name: '外国护照',
                val: 'G',
            }, {
                name: '外国人永久居留身份证',
                val: 'H',
            }, {
                name: '外国人工作许可证（A类）',
                val: 'I',
            }, {
                name: '外国人工作许可证（B类）',
                val: 'J',
            }, {
                name: '外国人工作许可证（C类）',
                val: 'K',
            }
        ],
        filed: [{
                name: "序号",
                colname: "IntExcelLine",
            },
            {
                name: "档案号",
                colname: "StrFileNo",
            }, {
                name: "姓名",
                colname: "StrEmpName",
            }, {
                name: "服务中心",
                colname: "StrSrvCent",
            }, {
                name: "劳动合同签署公司全称",
                colname: "StrBlCmp",
            }, {
                name: "项目名称",
                colname: "StrObjName",
            }, {
                name: "子项目",
                colname: "subProject",
            }, {
                name: "项目类别",
                colname: "StrProjectType",
            }, {
                name: "业务立项部门",
                colname: "StrObjInstName",
            }, {
                name: "负责客服",
                colname: "StrUserName",
            }, {
                name: "部门",
                colname: "StrDepName",
            }, {
                name: "岗位",
                colname: "StrJobInf",
            }, {
                name: "身份证",
                colname: "StrIdCard",
            }, {
                name: "政治面貌",
                colname: "StrPolitical",
            }, {
                name: "身份证有效终止时间",
                colname: "DtIcCareEdate",
            }, {
                name: "户粮",
                colname: "StrCityzenType",
            }, {
                name: "联系方式",
                colname: "StrPhoneNum",
            }, {
                name: "紧急联系人",
                colname: "StrContName",
            }, {
                name: "紧急联络方式",
                colname: "StrContTel",
            }, {
                name: "民族",
                colname: "StrNationClass",
            }, {
                name: "籍贯",
                colname: "StrNativePlace",
            }, {
                name: "户籍地址",
                colname: "StrNativeAddr",
            }, {
                name: "现住地址",
                colname: "StrAddr",
            }, {
                name: "教育程度",
                colname: "StrEduLv",
            }, {
                name: "参保种类",
                colname: "StrInsuranceType",
            }, {
                name: "参保日期",
                colname: "DtInsuranceDate",
            }, {
                name: "医保卡号",
                colname: "StrMedicalCard",
            }, {
                name: "用工之日",
                colname: "DtEntryBdate",
            }, {
                name: "合同（协议）类型",
                colname: "StrContractType",
            }, {
                name: "签定合同次数",
                colname: "IntContractNum",
            }, {
                name: "签订合同起止时间记录",
                colname: "StrContractBedate",
            }, {
                name: "试用期到期日期",
                colname: "DtProbationEdate",
            }, {
                name: "劳动合同起始时间",
                colname: "DtContractBtime",
            }, {
                name: "劳动合同到期时间",
                colname: "DtContractTime",
            }, {
                name: "在/离职状态",
                colname: "StrWorkState",
            }, {
                name: "离职日期",
                colname: "DtDepartureDate",
            }, {
                name: "实际离职日期",
                colname: "DtRealDepartureDate",
            }, {
                name: "银行卡号",
                colname: "StrBankCard",
            }, {
                name: "银行",
                colname: "StrBankName",
            }, {
                name: "是否计提",
                colname: "StrWithdrawal",
            }, {
                name: "市内",
                colname: "StrInCity",
            }, {
                name: "市外",
                colname: "StrOutsideCity",
            }, {
                name: "其他情况",
                colname: "StrOther",
            }, {
                name: "体检类型",
                colname: "StrPetype",
            }, {
                name: "体检结果",
                colname: "StrPeres",
            }, {
                name: "人员状态",
                colname: "StrEmpUsrStatus",
            }, {
                name: "工伤发生时间",
                colname: "DtInjuryBdate",
            }, {
                name: "伤残等级",
                colname: "StrDisabilityLevel",
            }, {
                name: "工伤纠纷结束时间",
                colname: "DtInjuryEdate",
            }, {
                name: "是否黑名单",
                colname: "StrBlacklist",
            }, {
                name: "黑名单原因",
                colname: "StrBlacklistReason",
            }, {
                name: "备注",
                colname: "StrRemark",
            },
        ],
        checkedFields: [{
                name: "档案号",
                colname: "StrFileNo",
            },
            {
                name: "姓名",
                colname: "StrEmpName",
            }, {
                name: "服务中心",
                colname: "StrSrvCent",
            }, {
                name: "劳动合同签署公司全称",
                colname: "StrBlCmp",
            }, {
                name: "项目名称",
                colname: "StrObjName",
            }
        ],
        bank: [
            "招商银行",
            "中国工商银行",
            "中国农业银行",
            "中国银行",
            "中国建设银行",
            "交通银行",
            "中信银行",
            "中国光大银行",
            "华夏银行",
            "中国民生银行",
            "广发银行股份有限公司",
            "平安银行原深圳发展银行",
            "兴业银行",
            "上海浦东发展银行",
            "中国邮政储蓄银行",
            "宁波银行",
            "浙江省农村信用社",
            "上海银行",
            "安徽省农村信用社联合社",
            "鞍山市商业银行",
            "包商银行股份有限公司",
            "保定银行",
            "北京农村商业银行",
            "北京顺义银座村镇银行",
            "北京银行",
            "北屯国民村镇银行",
            "博乐国民村镇银行",
            "渤海银行",
            "沧州银行",
            "昌吉国民村镇银行",
            "常熟农村商业银行",
            "成都农村商业银行股份有限公司",
            "成都银行",
            "承德银行",
            "大连银行",
            "丹东银行清算中心",
            "德阳银行",
            "德州银行",
            "东莞农村商业银行",
            "东莞银行",
            "东兴国民村镇银行",
            "东亚银行中国有限公司",
            "东营莱商村镇银行股份有限公司",
            "东营银行",
            "鄂尔多斯银行",
            "防城港防城国民村镇银行",
            "福建海峡银行",
            "福建省农村信用社",
            "阜新银行结算中心",
            "富邦华一银行",
            "富滇银行",
            "甘肃银行",
            "赣州银行",
            "广东华兴银行",
            "广东南粤银行股份有限公司",
            "广东省农信",
            "广发银行股份有限公司",
            "广西北部湾银行",
            "广西农村信用社合作银行",
            "广西浦北国民村镇银行",
            "广西钦州钦南国民村镇银行",
            "广西上林国民村镇银行",
            "广西银行国民村镇银行",
            "广州农村商业银行",
            "广州银行",
            "贵阳银行",
            "贵州省农村信用社联合社",
            "贵阳银行",
            "贵州省农村信用社联合社",
            "贵州银行",
            "桂林银行股份有限公司",
            "哈尔滨银行结算中心",
            "哈尔滨银行结算中心",
            "哈密红星国民村镇银行",
            "海口联合农村商业银行",
            "海南省农村信用社",
            "海南银行股份有限公司",
            "邯郸市商业银行",
            "韩亚银行",
            "汉口银行",
            "杭州银行",
            "合浦国民村镇银行",
            "河北银行股份有限公司",
            "河南省农信联社",
            "恒丰银行",
            "衡水银行",
            "葫芦岛银行",
            "湖北农信",
            "湖北银行",
            "湖州银行",
            "花旗银行",
            "华融湘江银行",
            "华瑞银行",
            "华夏银行",
            "黄河农村商业银行",
            "徽商银行",
            "吉林农村信用社",
            "吉林银行",
            "济宁银行",
            "嘉兴银行清算中心",
            "江南农村商业银行",
            "江苏省农村信用社联合社",
            "江苏银行股份有限公司",
            "江苏长江商行",
            "江西赣州银座村镇银行",
            "江阴农商银行",
            "交通银行",
            "焦作中旅银行",
            "金华银行股份有限公司",
            "锦州银行",
            "晋城银行",
            "晋商银行网上银行",
            "晋中银行",
            "九江银行股份有限公司",
            "克拉玛依金龙国民村镇银行",
            "奎屯国民村镇银行",
            "昆仑银行",
            "昆山农村商业银行",
            "莱商银行",
            "兰州银行股份有限公司",
            "廊坊银行",
            "乐山市商业银行",
            "辽宁省农村信用社联合社运营管理部",
            "辽阳银行股份有限公司",
            "临商银行",
            "柳州银行",
            "龙江银行",
            "泸州市商业银行",
            "洛阳银行",
            "绵阳市商业银行",
            "南昌银行",
            "南充市商业银行",
            "南京银行",
            "内蒙古银行",
            "宁波通商银行股份有限公司",
            "宁波银行",
            "宁夏银行",
            "农村信用社",
            "攀枝花市商业银行",
            "平安银行原深圳发展银行",
            "平顶山银行",
            "平果国民村镇银行",
            "齐鲁银行",
            "齐商银行",
            "企业银行",
            "青岛银行",
            "青海银行",
            "曲靖市商业银行",
            "泉州银行",
            "日照银行",
            "厦门国际银行",
            "厦门银行",
            "山东省农联社",
            "陕西信合",
            "上海农商银行",
            "上海浦东发展银行",
            "上海银行",
            "上饶银行",
            "绍兴银行",
            "深圳福田银座村镇银行",
            "深圳农商行",
            "深圳前海微众银行",
            "盛京银行",
            "石河子国民村镇银行",
            "石嘴山银行",
            "顺德农村商业银行",
            "四川省联社",
            "苏州银行",
            "遂宁商行",
            "台州银行",
            "太仓农商行",
            "泰安银行",
            "天津滨海农村商业银行股份有限公司",
            "天津农商银行",
            "天津银行",
            "威海市商业银行",
            "潍坊银行",
            "温州银行",
            "乌海银行",
            "乌鲁木齐银行",
            "无锡农村商业银行",
            "吴江农村商业银行",
            "五家渠国民村镇银行",
            "武汉农村商业银行",
            "西安银行",
            "象山国民村镇银行",
            "新韩银行中国",
            "新疆绿洲国民村镇银行",
            "邢台银行",
            "兴业银行",
            "烟台银行",
            "伊犁国民村镇银行",
            "宜宾市商业银行",
            "鄞州银行",
            "营口沿海银行股份有限公司",
            "营口银行",
            "友利银行",
            "玉溪市商业银行",
            "云南省农村信用社",
            "枣庄银行",
            "张家港农村商业银行",
            "张家口市商业银行",
            "长安银行",
            "长沙银行",
            "浙江稠州商业银行",
            "浙江景宁银座村镇银行",
            "浙江民泰商业银行",
            "浙江三门银座村镇银行",
            "浙江省农村信用社",
            "浙江泰隆商业银行",
            "浙江网商银行",
            "浙商银行",
            "郑州银行",
            "中德银行",
            "中国工商银行",
            "中国光大银行",
            "中国建设银行",
            "中国民生银行",
            "中国农业银行",
            "中国银行",
            "中国邮政储蓄银行",
            "中信银行",
            "中原银行",
            "重庆富民银行",
            "重庆农村商业银行",
            "重庆黔江银座村镇银行",
            "重庆三峡银行",
            "重庆银行股份有限公司",
            "重庆渝北银座村镇银行",
            "珠海华润银行清算中心",
            "自贡市商业银行清算中心"
        ],
        CityzenType: [
            "市区非农业户口",
            "省内非农业户口",
            "省外非农业户口",
            "市区农业户口",
            "省内农业户口",
            "省外农业户口",
            "港澳台",
            "外籍",
            "城镇",
            "农村",
            "居",
            "农"
        ],
        //分公司
        SrvCent: [
            "宁波分公司",
            "杭州分公司",
            "上海分公司 ",
            "济南分公司",
            "丽水分公司",
            "武汉分公司",
            "温州分公司",
            "广州分公司",
            "台州分公司",
            "长沙分公司",
            "厦门分公司",
            "成都分公司",
            "深圳分公司",
            "重庆分公司"
        ],
        //合同类型
        ContractType: [
            "劳动合同",
            "退休返聘协议",
            "实习协议",
            "兼职协议",
            "自由职业者服务协议",
            "劳务协议",
            "非全日制用工协议"
        ],
        //保险
        InsuranceType: [
            "大商保+小商保",
            "鄞州基本险",
            "小商保",
            "大商保",
            "鄞州外来务工险",
            "社保",
            "社保+小商保",
            "社保+大商保"
        ],
        //学历水平
        eduLv: [
            "博士研究生",
            "硕士研究生",
            "大学本科",
            "大学专科",
            "中等专科",
            "职业高中",
            "技工学校",
            "普通中学",
            "初级中学",
            "小学",
            "其他"
        ],
        //民族
        nationals: [
            "汉族",
            "蒙古族",
            "回族",
            "苗族",
            "傣族",
            "傈僳族",
            "藏族",
            "壮族",
            "朝鲜族",
            "高山族",
            "纳西族",
            "布朗族",
            "阿昌族",
            "怒族",
            "鄂温克族",
            "鄂伦春族",
            "赫哲族",
            "门巴族",
            "白族",
            "保安族",
            "布依族",
            "达斡尔族",
            "德昂族",
            "东乡族",
            "侗族",
            "独龙族",
            "俄罗斯族",
            "哈尼族",
            "哈萨克族",
            "基诺族",
            "京族",
            "景颇族",
            "柯尔克孜族",
            "拉祜族",
            "黎族",
            "珞巴族",
            "满族",
            "毛南族",
            "仫佬族",
            "普米族",
            "羌族",
            "撒拉族",
            "畲族",
            "水族",
            "塔吉克族",
            "塔塔尔族",
            "土家族",
            "仡佬族",
            "土族",
            "佤族",
            "维吾尔族",
            "乌孜别克族",
            "锡伯族",
            "瑶族",
            "裕固族",
            "彝族"
        ],
        //合同/协议
        contractList: [{
                name: 'P劳动合同',
                val: 1,
                no: 1,
                jobNameLabel: ''
            },
            {
                name: 'P劳动合同sdh',
                val: 2,
                no: 2,
                jobNameLabel: '工作岗位'
            }, {
                name: '温州交投项目',
                val: 2,
                no: 23,
                jobNameLabel: '工作岗位'
            }, {
                name: 'P实习管理协议',
                val: 3,
                no: 3,
                jobNameLabel: '工作岗位(A管理类、B技术类、C操作类)'
            }, {
                name: 'P实习管理协议（社会未成年工）',
                val: 4,
                no: 4,
                jobNameLabel: '工作岗位(A管理类、B技术类、C操作类)'
            }, {
                name: 'P退休返聘协议',
                val: 4,
                no: 5,
                jobNameLabel: '工作岗位(A管理、B技术、C操作)'
            }, {
                name: 'P兼职协议',
                val: 4,
                no: 6,
                jobNameLabel: '工作岗位(A管理、B技术、C操作)'
            }, {
                name: 'P劳务协议',
                val: 4,
                no: 7,
                jobNameLabel: '工作岗位'
            }, {
                name: 'Y劳动合同',
                val: 5,
                no: 8,
                jobNameLabel: '工作岗位'
            }, {
                name: 'Y劳务协议2026',
                val: 4,
                no: 30,
                jobNameLabel: '服务内容'
            }, {
                name: 'Y劳动合同（无固定期限）',
                val: 5,
                no: 22,
                jobNameLabel: '工作岗位'
            }, {
                name: 'Y非全日制用工协议',
                val: 6,
                no: 9,
                jobNameLabel: '工作岗位(A管理、B技术、C操作)'
            }, {
                name: 'Y实习协议',
                val: 3,
                no: 10,
                jobNameLabel: '工作岗位(A管理、B技术、C操作)'
            }, {
                name: 'Y实习协议（社会未成年工）',
                val: 4,
                no: 11,
                jobNameLabel: '工作岗位(A管理、B技术、C操作)'
            }, {
                name: 'Y退休返聘协议',
                val: 4,
                no: 12,
                jobNameLabel: '工作岗位(A管理、B技术、C操作)'
            }, {
                name: 'Y兼职协议',
                val: 4,
                no: 13,
                jobNameLabel: '工作岗位(A管理、B技术、C操作)'
            }, {
                name: 'Y劳务协议',
                val: 4,
                no: 14,
                jobNameLabel: '工作岗位'
            }, {
                name: 'H劳动合同',
                val: 5,
                no: 15,
                jobNameLabel: '工作岗位'
            }, {
                name: '终止（解除）劳动合同证明（含非全日制用工）',
                val: 8,
                no: 16,
                jobNameLabel: '工作岗位'
            }, {
                name: '终止（解除）就业（实习）协议证明',
                val: 9,
                no: 17,
                jobNameLabel: '工作岗位'
            }, {
                name: '终止（解除）其他协议证明（如兼职协议、退休返聘协议等）',
                val: 10,
                no: 18,
                jobNameLabel: '工作岗位'
            }, {
                name: '终止（解除）劳务协议申请',
                val: 10,
                no: 31,
                jobNameLabel: '工作岗位'
            }, {
                name: '终止（解除）协议/劳动合同证明（西南通用）',
                val: 12,
                no: 20,
                jobNameLabel: '工作岗位'
            }, {
                name: '终止 (解除）劳动合同证明（无固定期限）',
                val: 13,
                no: 21,
                jobNameLabel: '工作岗位'
            }, {
                name: '重庆保利物业劳动合同（简易）',
                val: 2,
                no: 24,
                jobNameLabel: '工作岗位'
            }, {
                name: '重庆保利物业劳动合同（详细）',
                val: 2,
                no: 27,
                jobNameLabel: '工作岗位'
            }, {
                name: '重庆保利物业劳务协议',
                val: 5,
                no: 28,
                jobNameLabel: '工作岗位'
            }, {
                name: '重庆保利物业实习协议',
                val: 3,
                no: 29,
                jobNameLabel: '工作岗位'
            },
            {
                name: '暂缓缴纳（补贴）社保申请书',
                val: 11,
                no: 25,
                jobNameLabel: '工作岗位'
            }, {
                name: '重庆保利物业解除（终止）劳动关系证明书',
                val: 8,
                no: 26,
                jobNameLabel: '工作岗位'
            }, {
                name: '重庆保利物业解除（终止）返聘协议证明书',
                val: 8,
                no: 26,
                jobNameLabel: '工作岗位'
            }, {
                name: '重庆保利物业解除（终止）实习协议证明书',
                val: 8,
                no: 26,
                jobNameLabel: '工作岗位'
            }, {
                name: '成都中铁房地产维保劳动合同',
                val: 5,
                no: 32,
                jobNameLabel: '工作岗位'
            }, {
                name: '成都中铁房地产后勤劳动合同',
                val: 5,
                no: 33,
                jobNameLabel: '工作岗位'
            },{
                name: '成都中铁房地产营销劳动合同',
                val: 5,
                no: 34,
                jobNameLabel: '工作岗位'
            }, {
                name: '成都长河通讯劳动合同(工作任务)',
                val: 5,
                no: 35,
                jobNameLabel: '工作岗位'
            },{
                name: '成都长河通讯劳动合同(固定期限)',
                val: 5,
                no: 36,
                jobNameLabel: '工作岗位'
            }, {
                name: '其他',
                val: 11,
                no: 19,
                jobNameLabel: '工作岗位'
            }
        ],
        bntList: ['30万小商保', '60万大商保', '90万大小商保', '50万商保（超龄人员保安保洁岗位）', '30万小商保（建筑业）', '60万大商保（建筑业）', '90万大小商保（建筑业）', '90万日商保（1-4类）', '100万雇主责任险', '30万新业态伤害险', '60万新业态伤害险', '90万新业态伤害险', '源和健康险'],
        list: [{
                img: '../../assets/joball_Img/workBench/inter.svg',
                title: '待我处理',
                num: 'pendingcont',
                color: '#EE5122',
                active: 0,
                name: '已报名'
            },
            {
                img: '../../assets/joball_Img/workBench/interToday.svg',
                title: '今日待面试',
                num: 'interttodaycont',
                active: 1,
                name: '约面'
            }, {
                img: '../../assets/joball_Img/workBench/interTomorrow.svg',
                title: '明日待面试',
                num: 'interttorrcont',
                active: 1,
                name: '约面'
            }, {
                img: '../../assets/joball_Img/workBench/entry.svg',
                title: '待入职',
                num: 'beempcont',
                color: '#EE5122',
                active: 2,
                name: '通过'
            }, {
                img: '../../assets/joball_Img/workBench/entryMonth.svg',
                title: '本月入职',
                num: 'entrymouthcont',
                active: 3,
                name: '入职'
            }, {
                img: '../../assets/joball_Img/workBench/quitMonth.svg',
                title: '今日离职',
                num: 'quitcont',
                active: 5,
                name: '离职'
            }
        ],
        list3: [{
                img: '../../assets/joball_Img/workBench/inter.svg',
                title: '待面试',
                num: 'pendingcont',
                color: '#EE5122',
                active: 1,
                name: '约面'
            },
            {
                img: '../../assets/joball_Img/workBench/entry.svg',
                title: '待入职',
                num: 'entrycont',
                active: 2,
                name: '通过'
            }, {
                img: '../../assets/joball_Img/workBench/currentlyActive.svg',
                title: '当前在职',
                num: 'beworkcont',
                color: '#EE5122',
                active: 3,
                name: '入职'
            }, {
                img: '../../assets/joball_Img/workBench/entryMonth.svg',
                title: '本月入职',
                num: 'entrymouthcont',
                active: 3,
                name: '入职'
            }, {
                img: '../../assets/joball_Img/workBench/quitMonth.svg',
                title: '本月离职',
                num: 'quitmouthcont',
                active: 5,
                name: '离职'
            }, {
                img: '../../assets/joball_Img/workBench/entryWeek.svg',
                title: '本周入职',
                num: 'entryweekcont',
                color: '#EE5122',
                active: 3,
                name: '入职'
            }, {
                img: '../../assets/joball_Img/workBench/quitWeek.svg',
                title: '本周离职',
                num: 'quitweekcont',
                active: 5,
                name: '离职'
            }
        ],
        //在职表格表头
        tableTitle: [{
                StrColumId: 'strEmpName',
                StrColumName: '姓名',
                type: ''
            },
            {
                StrColumId: 'strIdCard',
                StrColumName: '身份证号码',
                type: ''
            }, {
                StrColumId: 'strObjName',
                StrColumName: '项目名称',
                type: ''
            }, {
                StrColumId: 'nowFileNo',
                StrColumName: '档案号',
                type: ''
            }, {
                StrColumId: 'strDepName',
                StrColumName: '部门',
                type: ''
            }, {
                StrColumId: 'strJobInf',
                StrColumName: '岗位',
                type: ''
            }, {
                StrColumId: 'insureJob',
                StrColumName: '商保岗位',
                type: ''
            }, {
                StrColumId: 'strOther',
                StrColumName: '临时工',
                type: ''
            }, {
                StrColumId: 'gender',
                StrColumName: '性别',
                type: ''
            }, {
                StrColumId: 'age',
                StrColumName: '年龄',
                type: ''
            }, {
                StrColumId: 'dtIcCareEdate',
                StrColumName: '身份证有效终止日期',
                type: 'date'
            }, {
                StrColumId: 'strCityzenType',
                StrColumName: '户粮',
                type: ''
            }, {
                StrColumId: 'strNationClass',
                StrColumName: '民族',
                type: ''
            }, {
                StrColumId: 'strNativeAddr',
                StrColumName: '户籍地址',
                type: ''
            }, {
                StrColumId: 'strAddr',
                StrColumName: '现住地址',
                type: ''
            }, {
                StrColumId: 'strEduLv',
                StrColumName: '教育程度',
                type: ''
            }, {
                StrColumId: 'strPhoneNum',
                StrColumName: '联系方式',
                type: ''
            }, {
                StrColumId: 'strContName',
                StrColumName: '紧急联系人',
                type: ''
            }, {
                StrColumId: 'strContTel',
                StrColumName: '紧急联系方式',
                type: ''
            }, {
                StrColumId: 'strInsuranceType',
                StrColumName: '参保种类',
                type: ''
            }, {
                StrColumId: 'dtInsuranceDate',
                StrColumName: '参保日期',
                type: ''
            }, {
                StrColumId: 'socialInsuranceAccount',
                StrColumName: '社保参保账户',
                type: ''
            }, {
                StrColumId: 'providentFundAccount',
                StrColumName: '公积金参保账户',
                type: ''
            }, {
                StrColumId: 'providentFundNumber',
                StrColumName: '公积金基数',
                type: ''
            }, {
                StrColumId: 'providentFundRate',
                StrColumName: '公积金缴纳比例',
                type: ''
            }, {
                StrColumId: 'dtEntryBdate',
                StrColumName: '用工之日',
                type: 'date'
            }, {
                StrColumId: 'strContractType',
                StrColumName: '合同（协议）类型',
                type: ''
            }, {
                StrColumId: 'dtProbationEdate',
                StrColumName: '试用期到期日期',
                type: 'date'
            }, {
                StrColumId: 'dtContractBtime',
                StrColumName: '劳动合同起始时间',
                type: 'date'
            }, {
                StrColumId: 'dtContractTime',
                StrColumName: '劳动合同到期时间',
                type: 'date'
            }, {
                StrColumId: 'strWorkState',
                StrColumName: '在/离职状态',
                type: ''
            }, {
                StrColumId: 'dtDepartureDate',
                StrColumName: '离职日期',
                type: 'date'
            }, {
                StrColumId: 'dtRealDepartureDate',
                StrColumName: '实际离职日期',
                type: 'date'
            }, {
                StrColumId: 'strBankName',
                StrColumName: '银行',
                type: ''
            }, {
                StrColumId: 'strBankCard',
                StrColumName: '银行卡号',
                type: ''
            }, {
                StrColumId: 'pushName',
                StrColumName: '推荐渠道',
                type: ''
            }, {
                StrColumId: 'pushRemark',
                StrColumName: '推荐渠道备注',
                type: ''
            }, {
                StrColumId: 'strservuserid',
                StrColumName: '客服人员',
                type: ''
            }, {
                StrColumId: 'isInsured',
                StrColumName: '是否参保',
                type: ''
            }, {
                StrColumId: 'isSigning',
                StrColumName: '是否签约',
                type: ''
            }, {
                StrColumId: 'isOnline',
                StrColumName: '签约类型',
                type: ''
            }, {
                StrColumId: 'salaryCompanyName',
                StrColumName: '发薪公司全称',
                type: ''
            }, {
                StrColumId: 'contractCompanyName',
                StrColumName: '合同公司全称',
                type: ''
            }, {
                StrColumId: 'customerName',
                StrColumName: '客户单位全称',
                type: ''
            }, {
                StrColumId: 'strProjectType',
                StrColumName: '项目类别',
                type: ''
            }, {
                StrColumId: 'strObjInstName',
                StrColumName: '业务立项部门',
                type: ''
            }
        ],
        //入离职报表表头
        reportTableTitle: [{
                StrColumId: 'strDep1',
                StrColumName: '区域'
            },
            {
                StrColumId: 'strDep2',
                StrColumName: '服务中心'
            }, {
                StrColumId: 'strDep3',
                StrColumName: '服务部门'
            }, {
                StrColumId: 'strservuserid',
                StrColumName: '客服'
            }, {
                StrColumId: 'strprojectName',
                StrColumName: '项目名称'
            }, {
                StrColumId: 'actualtype',
                StrColumName: '业务类型'
            }, {
                StrColumId: 'strpartner2',
                StrColumName: '合伙人'
            }, {
                StrColumId: 'strAchieveowner',
                StrColumName: '业绩归属人'
            }, {
                StrColumId: 'strEmpName',
                StrColumName: '姓名'
            }, {
                StrColumId: 'strIdCard',
                StrColumName: '身份证号码'
            }, {
                StrColumId: 'dtEntryBDate',
                StrColumName: '用工之日'
            }, {
                StrColumId: 'dtRealDepartureDate',
                StrColumName: '实际离职时间'
            }, {
                StrColumId: 'strWorkState',
                StrColumName: '在/离职状态'
            }, {
                StrColumId: 'jobDays',
                StrColumName: '在职天数'
            }, {
                StrColumId: 'reEmployment',
                StrColumName: '是否再次入职'
            }, {
                StrColumId: 'addDate',
                StrColumName: '创建时间'
            }, {
                StrColumId: '社招推荐人',
                StrColumName: '社招推荐人'
            }, {
                StrColumId: '网招中心',
                StrColumName: '网招中心'
            }, {
                StrColumId: '公司渠道',
                StrColumName: '公司渠道'
            }, {
                StrColumId: '校招部',
                StrColumName: '校招部'
            }, {
                StrColumId: '业务项目部',
                StrColumName: '业务项目部'
            }, {
                StrColumId: '招聘部',
                StrColumName: '招聘部'
            }, {
                StrColumId: '客服部',
                StrColumName: '客服部'
            }, {
                StrColumId: '宁波网招',
                StrColumName: '宁波网招'
            }, {
                StrColumId: '小杰门店',
                StrColumName: '小杰门店'
            }, {
                StrColumId: '企业转移',
                StrColumName: '企业转移'
            }, {
                StrColumId: '员工内荐',
                StrColumName: '员工内荐'
            }, {
                StrColumId: '供应商',
                StrColumName: '供应商'
            }, {
                StrColumId: '其他情况',
                StrColumName: '其他情况'
            },
        ],
    },
    mutations: {}
};

export default emp;